<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Penggunaan Data</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/penggunaandata">Penggunaan Data</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Penggunaan Data</h4>
                  <p class="card-title-desc mb-0">Memuat nama atau tolok indikator, satuan, dan entitas selain data. Anda juga dapat untuk menampilkan atau tidak pada halaman muka.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th>Urai Penggunaan</th>
                      <th>Publish</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in penggunaandata" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row" v-text="row.urai"></td>
                      <td scope="row">{{ row.is_published == 'Y' ? 'Ya' : 'Tidak' }}</td>
                      <td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="penggunaandata.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Penggunaan'" backdrop="static">
    <template #default>
      <form @submit.prevent="action">
        <div class="mb-3">
          <label for="indikator" class="form-label">Urai Penggunaan</label>
          <input v-model="form.urai" type="text" class="form-control" id="indikator" />
        </div>
        <div class="mb-3">
          <label for="deskripsi" class="form-label">Deskripsi</label>
          <textarea v-model="form.deskripsi" id="deskripsi" rows="4" class="form-control"></textarea>
        </div>
        <div class="mb-3 form-check">
          <input v-model="form.is_published" type="checkbox" class="form-check-input" id="publish">
          <label class="form-check-label" for="publish">Publikasi</label>
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    penggunaandata: Array
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        urai: '',
        deskripsi: '',
        is_published: false
      },
    }
  },
  methods: {
    edit({ id, urai, deskripsi, is_published }) {
      this.form.id = id;
      this.form.urai = urai;
      this.form.deskripsi = deskripsi;
      this.form.is_published = (is_published == 'Y');
      this.form.show = true;
      console.log(this.form.id)
    },
    action() {
      if(this.form.id) {
        this.$inertia.put('/admin/penggunaandata/' + this.form.id, this.form);
      } else {
        this.$inertia.post('/admin/penggunaandata', this.form);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.urai = '';
      this.form.deskripsi = '';
      this.form.is_published = false;
    },
    remove(row) {
      this.$inertia.delete('/admin/penggunaandata/' + row.id);
    }
  },
}
</script>
